import React from 'react';
import ReactCodeInput from 'react-code-input';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  codeInput: {
    display: 'flex !important',
    flexWrap: 'nowrap',
    '& > input': {
      marginRight: 10,
      MozAppearance: 'textfield',
      width: 58,
      borderRadius: 4,
      fontSize: '1rem',
      height: 64,
      backgroundColor: theme.palette.gray.background,
      color: theme.palette.common.black,
      textAlign: 'center',
      border: '0px',
      [theme.breakpoints.down('sm')]: {
        marginRight: 2,
        width: 'auto',
        flex: 1,
        minWidth: 0,
        height: 48,
      },
      outline: 'none',
    },
    '& > input:last-child': {
      marginRight: 0,
    },
  },
}));

export default function CodeInput(props) {
  const { onChange, className, ...rest } = props;
  const classes = useStyles();

  const onChangeHandler = React.useCallback((value) => onChange && onChange(value, rest.name), [onChange, rest.name]);

  return (
    <ReactCodeInput {...rest} fields={6} className={clsx(classes.codeInput, className)} onChange={onChangeHandler} />
  );
}
